<template>
  <component :is="dynamicTag" :href="dynamicHref" class="page-item" :class="{ disabled: disabled }">
    <div class="row" @click="clickPage">
      <div class="col-7">
        <div class="page-data">
          <div class="page-icon mr-1">
            <i class="icon" :class="iconType"></i>
          </div>
          <div class="page-info">
            <h4 class="d-flex page-name typo-paragraph12 typo-medium mb-half">
              <AbTestingTooltip small jsTooltip v-if="isRunningAbTesting" />
              <span> {{ pageName }}</span>
            </h4>
            <p class="page-time typo-paragraph10 typo-regular">{{ $t("search.last") }} {{ timeago }}</p>
          </div>
        </div>
      </div>
      <div class="col-3 d-flex flex-column align-items-center justify-content-center" v-if="isPublishScheduled">
        <p class="typo-paragraph12 typo-regular text-success text-center d-flex align-items-center">
          <ScheduleIcon />
          <span class="ml-half">{{ $t("page.scheduledAt", { time: publishScheduleAt }) }}</span>
        </p>
      </div>
      <div class="col-2 ml-auto d-flex justify-content-end">
        <!-- <div class="btn btn-clean page-action" @click.stop.prevent="previewMe" v-popover:tooltip.bottom="$t('generals.preview')">
          <i class="icon icon-view"></i>
        </div> -->
        <a :href="previewUrl" target="_BLANK" class="page-action" :class="{ disabled: !item.previewUrl }" v-popover:tooltip.bottom="$t('generals.preview')">
          <i class="icon icon-preview" :class="[item.previewUrl ? 'text-dark-high-contrast' : 'text-dark-low-contrast']"></i>
        </a>
      </div>
    </div>
  </component>
</template>

<script>
import { mapGetters } from "vuex";
import TimeMaker from "@/plugins/timemaker";
import schedulePublish from '@/mixins/schedulePublish';
import ScheduleIcon from '@/core/shared/ScheduleIcon.vue';
import AbTestingTooltip from "@/core/components/AbTestingTooltip.vue";

export default {
  name: "PageResult",
  components: { 
    ScheduleIcon,
    AbTestingTooltip
  },
  mixins: [schedulePublish("item")],
  props: {
    type: String,
    item: Object,
    disabled: {
      type: Boolean,
      default: false
    }
    // padding: {
    //   type: String,
    //   default: "px-2 py-1"
    // }
  },
  data() {
    return {
      textDefault: {
        "Theme Product Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Collection Template": this.$t("page.defaultShopifyTemplate"),
        "Theme Index Template": this.$t("page.defaultShopifyTemplate"),
        "Your first Homepage": this.$t("page.defaultShopifyTemplate")
      }
    };
  },
  computed: {
    ...mapGetters("account", {
      language: "displayLanguage"
    }),
    pageName() {
      if (this.item && this.item.title) return this.item.title;
      return "";
    },
    isOriginalShopifyPage() {
      return this.item && this.textDefault[this.item.title];
    },
    isRunningAbTesting() {
      return this.item.runningCampaignId > 0;
    },
    previewUrl() {
      return this.item && this.item.previewUrl;
    },
    dynamicTag() {
      return this.isOriginalShopifyPage || this.isRunningAbTesting || this.disabled ? "section" : "a";
    },
    dynamicHref() {
      if (!this.isOriginalShopifyPage && !this.isRunningAbTesting && !this.disabled) {
        return this.item.editUrl;
      }
      return null;
    },
    iconType() {
      switch (this.item.type) {
        case "template-page": {
          return "icon-landingpages";
        }
        case "template-index": {
          return "icon-homepages";
        }
        case "template-collection": {
          return "icon-collectionpages";
        }
        case "template-product": {
          return "icon-productpages";
        }
        case "template-article": {
          return "icon-blog";
        }
        default: {
          return "icon-landingpages";
        }
      }
    },
    timeago() {
      return new TimeMaker(this.item.updated_at).ago(this.language);
    }
  },
  methods: {
    previewMe() {
      this.$emit("preview", this.item);
    },
    clickPage() {
      if (this.isRunningAbTesting) {
        this.$store.commit("page/OPEN_AB_TESTING_BLOCK_MODAL", this.item.runningCampaignId);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.page-item {
  background: $black2;
  padding: 9px 16px 10px 16px;
  .page-data {
    display: flex;
    align-items: center;
  }
  .page-icon {
    font-size: 20px;
    color: $textDarkModeLowContrast;
  }
  .page-info {
    // display: block;
    max-width: calc(100% - 8px - 20px);
  }
  .page-name {
    color: $textDarkModeHighContrast;
    display: block;
    max-width: 100%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .page-time {
    color: $textDarkModeLowContrast;
  }
  .page-action {
    @include flex-center(inline-flex);
    font-size: 16px;
    width: 32px;
    height: 32px;
    border-radius: $radius;
    color: $textDarkModeHighContrast;
    @include trans-all;
    &:not(.disabled):hover {
      background: $dark1;
    }
    &.disabled {
      pointer-events: none;
      cursor: default !important;
    }
  }

  &:not(.disabled) {
    cursor: pointer;
  }

  &:hover {
    background: $black3;
  }

}
</style>
